export enum GameType {
    DOLL,
    DRESS,
    HIEROGLYPH,
    MASK,
    QUILT,
    NUM_ELEMENTS,
}

export const GAME_ITEM_COUNT: number[] = [
    2, // DOLL
    2, // DRESS
    1, // HIEROGLYPH
    6, // MASK
    2, // QUILT
];
